import { makeStyles } from '@material-ui/core/styles'
import ImageBannerDesktop from 'assets/illustrations/kitdigital/banner-d.jpg'

const useStyles = makeStyles(theme => ({
  prebannerbody3: {
    fontSize: '.6rem',
    maxWidth: '465px',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(1),
    },
  },
  prebannerSeparator: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '160px',
  },
  prebanner: {
    textAlign: 'center',
    color: theme.palette.grey[200],
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(8),
      paddingTop: theme.spacing(8),
    },
  },
  prebannerLogosContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(8),
    marginTop: theme.spacing(4),
    maxWidth: '585px',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '1128px',
    },
  },
  prebannerLogos: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  prebannerLogoR: {
    flexGrow: 1,
    textAlign: 'center',
  },
  banner: {
    backgroundColor: theme.palette.common.white,
    marginTop: theme.spacing(-8),
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      backgroundImage: `url(${ImageBannerDesktop})`,
      backgroundSize: 'cover',
      backgroundPosition: 'bottom',
      backgroundRepeat: 'no-repeat',
      marginBottom: theme.spacing(4),
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(11),
    },
  },
  bannerSecondBlock: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  bannerTitle: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
    fontSize: 36,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  bannerSubtitle: {
    color: theme.palette.grey[200],
    marginBottom: theme.spacing(4),
    fontSize: 20,
    fontWeight: 600,
  },
  bannerButton: {
    backgroundColor: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  feature: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
      marginLeft: theme.spacing(-1),
    },
  },
  featureHeading: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(1),
    fontSize: 24,
  },
  featureText: {
    color: theme.palette.grey[200],
    fontSize: 16,
  },
  featureSubtitle: {
    color: theme.palette.grey[200],
    fontSize: 16,
    marginBottom: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  featureSubtitleBold: {
    color: theme.palette.grey[200],
    fontSize: 20,
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  featureTitle: {
    color: theme.palette.primary.dark,
    fontSize: 36,
    paddingTop: theme.spacing(1),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '60%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  featureImage: {
    maxWidth: theme.spacing(13),
    marginBottom: theme.spacing(1),
  },
  featureDivider: {
    marginTop: 90,
    marginBottom: 30,
  },
  featureDividerHorizontal: {
    marginTop: theme.spacing(5),
    marginBottom: 30,
  },
  sectionDownload: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(8),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.secondary.main,
  },
  sectionDownloadTitle: {
    color: theme.palette.primary.dark,
    fontSize: 20,
    fontWeight: 700,
    marginTop: theme.spacing(0),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(3),
      fontSize: theme.spacing(3),
    },
  },
  sectionDownloadButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.dark,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(3),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(2),
      textAlign: 'left',
    },
  },
}))

export default useStyles
